<!--华普事件-->
<template>
  <div class="hpEventBody">
    <!--今日告警事件-->
    <div class="todayEvent" :style="backImg('/huapu/eventFrom.png')">
      <p class="hpTitle">本月告警情况</p>
      <div class="eventChild">
        <div class="flexCenter roundDiv">
          <img :src="imgName('/huapu/digital.png')">
          <span>{{eventObj.monthAllCount}}</span>
          <span class="benyue">本月告警</span>
        </div>
        <div class="eventList">
          <ul>
            <li class="li">
              <div class="text"><span>未确认告警数</span><span>{{eventObj.monthWclCount}}</span></div>
              <div class="progress"><span
                  :style="'width:' +(eventObj.monthWclCount / (eventObj.monthWclCount + eventObj.monthAllCount) * 100) + '%'"></span>
              </div>
            </li>
            <li class="li">
              <div class="text"><span>预警数</span><span>{{eventObj.allYjCount}}</span></div>
              <div class="progress"><span
                  :style="'width:' +(eventObj.allYjCount / eventObj.allCount * 100) + '%'"></span></div>
            </li>
            <li class="li">
              <div class="text"><span>告警数</span><span>{{eventObj.allGjCount}}</span></div>
              <div class="progress"><span
                  :style="'width:' +(eventObj.allGjCount / eventObj.allCount * 100) + '%'"></span></div>
            </li>
          </ul>
        </div>
        <div class="box">
          <div class="li">
            <div class="txt">{{eventObj.lastMonthAllCount}}</div>
            <div class="name">上月同期</div>
          </div>
          <div class="li">
            <div class="txt">{{eventObj['lastMonthAllCount%']}}</div>
            <div class="name">环比增长</div>
          </div>
          <div class="li">
            <div class="txt">{{eventObj.lastYearMonthAllCount}}</div>
            <div class="name">上年同期</div>
          </div>
          <div class="li">
            <div class="txt">{{eventObj['lastYearMonthAllCount%']}}</div>
            <div class="name">同比增长</div>
          </div>
        </div>
      </div>

    </div>

    <!--本月工单完成工作-->
    <div class="thisMonthOrder" :style="backImg('/huapu/eventFrom.png')">
      <p class="hpTitle">报警占比</p>
      <div class="eventChild">
        <div style=" width: 80%; height: 100%;padding-right: 33px;">
          <vchart ref='vchartLine' themes="purple-passion" style="height: 100%;"></vchart>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import vchart from '@/components/module/chart/vchart.vue'
  import meterReadingStore from '@/page/system/meterReading/meterReadingStore.js'
  export default {
    components: {
      vchart,
    },
    data () {
      return {
        eventObj: {
          allCount: 116,
          allGjCount: 50,
          allYjCount: 66,
          lastMonthAllCount: 51,
          'lastMonthAllCount%': "5100.0%",
          lastYearMonthAllCount: 0,
          'lastYearMonthAllCount%': "0.0%",
          monthAllCount: 1,
          monthWclCount: 1,
        },
        option: {
          legend: {
            orient: 'vertical',
            top: '20',
            left: '20',
            icon: 'rect',
            itemHeight: 10,
            itemWidth: 10,
            textStyle: {
              color: '#fff',
              fontSize: 10
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          color: ['#e5c243','#28d7ad','#716eff'],
          series: [
            {
              name: '预警概况',
              type: 'pie',
              radius: ['50%','69%'],
              center: ['65%','55%'],
              label: {
                formatter: '{b}:{d}%',
                show: true,
                color: '#fff',
                fontSize: '10'
              },
              emphasis: {
                label: {
                  show: true,
                }
              },
              labelLine: {
                show: true
              },
              data: [
                {value: 33,name: '越限报警'},
                {value: 33,name: '变位报警'},
                {value: 33,name: '故障报警'},
              ]
            }
          ]
        }
      }
    },
    mounted () {
      this.init();
    },
    computed: {
      imgName () {
        return resourcesStore.getters.getResourcesByName
      },
      backImg () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      pieEarlyWarning () {
        return meterReadingStore.getters.getPieEarlyWarning
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
    },
    watch: {
      nowUnit (nv,ov) {
        this.init();
      },

    },
    methods: {
      init () {
        this.$api.eventApi.countEventListByUser(this.$store.userStore.state.nowUserInfo.id,this.nowUnit.id,'',-1,'','','','','',res => {

          this.option.series[0].data=[{value: res[1],name: '越限报警'},
          {value: res[2],name: '变位报警'},
          {value: res[3],name: '故障报警'},];
          this.$refs.vchartLine.setData(this.option,true)
        })


        // 本月告警情况
        this.$api.eventApi.countUnitEvents(this.nowUnit.id,res => {
          if(res=="正在获取中。。。请稍后") {
            setTimeout(() => {
              this.$api.eventApi.countUnitEvents(this.nowUnit.id,res => {
                this.eventObj=res
              })
            },7000);
          } else {
            this.eventObj=res
          }

        })
      },
    }
  }
</script>

<style scoped>
  .roundDiv .benyue {
    position: relative;
    margin-top: .75rem;
    font-size: 12px;
    white-space: nowrap;
  }

  .hpEventBody {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    padding: 10px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-around;
  }

  .todayEvent,
  .thisMonthEvent,
  .thisMonthOrder,
  .todayWork {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: calc(50% - 5px);
    height: 50%;
  }

  .thisMonthOrder {
    width: 100%;
  }

  .todayEvent {
    width: 100%;
  }

  p.hpTitle {
    font-size: 12px;
    color: white;
    padding-left: .2rem;
    padding-top: .1rem;
  }

  .todayWorkChild,
  .thisMonedefect {
    width: 100%;
    height: calc(50% - 5px);
  }

  .thisMonedefect {
    margin-top: 10px;
  }

  .hpEventBody span {
    color: white;
  }

  .eventList {
    width: 60%;
    height: 100%;
    overflow-y: overlay;
    margin-left: 15px;
    box-sizing: border-box;
    padding-right: 20px;
  }

  .eventList::-webkit-scrollbar {
    display: none
  }

  .eventList ul li {
    display: flex;
    align-items: center;
    padding-top: .1rem;
  }

  .eventList ul li span {
    font-size: 12px;
  }

  .thisMonthOrder .eventList ul li {}

  .eventChild {
    width: 100%;
    height: 70%;
    display: flex;
    align-items: center;
    margin-left: .1rem;
    margin-right: .1rem;
  }

  .roundDiv {
    width: 30%;
    height: 45%;
    position: relative;
  }

  .roundDiv img {
    height: 100%;
  }

  .roundDiv img,
  .roundDiv span {
    position: absolute;
  }

  .progressBar {
    width: 40%;
    background-color: #515A6E;
    height: .1rem;
    margin-left: .1rem;
    margin-right: .1rem;
  }

  .todayWorkChild textarea {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 10px 20px;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: white;
    outline: none;
  }

  .todayWorkChild textarea::-webkit-scrollbar {
    display: none
  }

  .defectText {
    width: 100%;
    height: 60%;
    overflow-y: overlay;
  }

  .defectText::-webkit-scrollbar {
    display: none
  }

  .defectText p {
    color: white;
    margin-left: .2rem;
    line-height: .2rem;
    font-size: 12px;
  }

  .workStar {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .workStar img {
    width: .25rem;
  }

  .eventList ul .li {
    display: flex;
    flex-direction: column;
    align-items: self-start;
  }

  .eventList ul .li .text {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 12px;
  }

  .eventList ul .li .progress {
    width: 100%;
    height: 6px;
    border-radius: 5px;
    background: #263445;
    overflow: hidden;
  }

  .eventList ul .li .progress>span {
    display: block;
    width: 50%;
    height: 100%;
    background: #448de3;
  }

  .eventChild>.box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
  }

  .eventChild>.box .li {
    width: 50%;
    color: #fff;
    text-align: center;

    margin-bottom: 20px;
  }

  .eventChild>.box .li .text {
    font-size: 12px;
  }

  .eventChild>.box .li .name {
    font-size: 12px;
    margin-top: 2px;
  }
</style>